"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "dresano": {
    "8c999a30": [{
      "hkey": "d788145f",
      "slug": "dresano",
      "name": "Dresano",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-belpensiero": [{
      "hkey": "d788145f",
      "slug": "dresano",
      "name": "Dresano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ca804716": [{
      "hkey": "d788145f",
      "slug": "dresano",
      "name": "Dresano",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "d788145f",
      "slug": "dresano",
      "name": "Dresano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7c30af2a": [{
      "hkey": "d788145f",
      "slug": "dresano",
      "name": "Dresano",
      "primary": true,
      "skipSearch": false
    }],
    "la-madonnina": [{
      "hkey": "d788145f",
      "slug": "dresano",
      "name": "Dresano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e47c6fbd": [{
      "hkey": "d788145f",
      "slug": "dresano",
      "name": "Dresano",
      "primary": true,
      "skipSearch": false
    }],
    "villaggio-ambrosiano": [{
      "hkey": "d788145f",
      "slug": "dresano",
      "name": "Dresano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;